function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Descriptions, Image, Row, Col, List, Skeleton, Button, Space, Drawer } from "antd";
import { Container } from "react-bootstrap";
import { PencilSquare, EyeFill, JournalText } from "react-bootstrap-icons";
import Moment from "react-moment";
import DisplayFile from "./DisplayFile";
import EditEmployeeContract from "./forms/EditEmployeeContract";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var EmployeeDetails = function EmployeeDetails(_ref) {
  var employee = _ref.employee;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showEditContract = _useState2[0],
    setShowEditContract = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showContractFile = _useState4[0],
    setShowContractFile = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedContract = _useState6[0],
    setSelectedContract = _useState6[1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: employee.photo == null ? /*#__PURE__*/_jsx(Image, {
            preview: false,
            width: "80px",
            src: "/drawables/avatar_default.png"
          }) : /*#__PURE__*/_jsx(Image, {
            preview: false,
            width: "80px",
            src: employee.photo
          })
        }), /*#__PURE__*/_jsxs(Col, {
          lg: 18,
          md: 18,
          children: [/*#__PURE__*/_jsxs(Descriptions, {
            title: /*#__PURE__*/_jsx("b", {
              children: "INFOS EMPLOYE(E)"
            }),
            column: 3,
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: "N\xBA Matricule",
              children: employee.lastname
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: "Nom",
              children: employee.lastname
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: "Pr\xE9nom",
              children: employee.firstname
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: "Poste",
              children: employee.job
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: "Contact",
              children: employee.mobile
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: "E-mail",
              children: employee.email
            }), /*#__PURE__*/_jsxs(Descriptions.Item, {
              label: "Salaire de base",
              children: [employee.base_salary.toLocaleString("Fr"), " GNF"]
            })]
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(List, {
            itemLayout: "vertical",
            dataSource: employee.employee_contracts,
            renderItem: function renderItem(item) {
              return /*#__PURE__*/_jsx(List.Item, {
                actions: [/*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setShowEditContract(true);
                    setSelectedContract(item);
                  },
                  children: /*#__PURE__*/_jsx(PencilSquare, {
                    size: 18
                  })
                }, "list-loadmore-edit"), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    setSelectedContract(item);
                    setShowContractFile(true);
                  },
                  children: /*#__PURE__*/_jsx(EyeFill, {
                    size: 18
                  })
                }, "list-loadmore-edit")],
                children: /*#__PURE__*/_jsx(List.Item.Meta, {
                  avatar: /*#__PURE__*/_jsx(JournalText, {
                    size: 20
                  }),
                  title: /*#__PURE__*/_jsx("b", {
                    children: item.title
                  }),
                  description: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: ["DU ", /*#__PURE__*/_jsx(Moment, {
                      date: item.from_date,
                      format: "DD/MM/YYYY"
                    }), " AU ", /*#__PURE__*/_jsx(Moment, {
                      date: item.to_date,
                      format: "DD/MM/YYYY"
                    })]
                  })
                })
              });
            }
          })]
        })]
      })
    }), selectedContract && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "CONTRAT"
        }),
        width: "70%",
        open: showContractFile,
        destroyOnClose: true,
        onClose: function onClose() {
          setShowContractFile(false);
        },
        children: /*#__PURE__*/_jsx(DisplayFile, {
          file_url: selectedContract.file
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        title: /*#__PURE__*/_jsx("b", {
          children: "MODIFIER LE CONTRAT"
        }),
        width: "340px",
        open: showEditContract,
        destroyOnClose: true,
        onClose: function onClose() {
          setShowEditContract(false);
        },
        children: /*#__PURE__*/_jsx(EditEmployeeContract, {
          contract: selectedContract
        })
      })]
    })]
  });
};
export default EmployeeDetails;